import { SharedModule } from "./../../../../shared/shared.module";
import { NgModule } from "@angular/core";
import { PricesTableCategoryItemsComponent } from "./prices-table-category-items.component";
import { CommonModule } from "@angular/common";

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [PricesTableCategoryItemsComponent],
  declarations: [PricesTableCategoryItemsComponent],
})
export class PricesTableCategoryItemsModule {}
